import React from 'react';
import { Box, Text } from '@chakra-ui/react';

export function Wordmark({ size = 'md' }) {
  const fontSize = size === 'lg' ? '1.5rem' : '1.15rem';
  return (
    <Box
      as="a"
      href="#"
      display="flex"
      alignItems="center"
      gap="2px"
      textDecoration="none"
      aria-label="yetzira.ai home"
    >
      <Text
        fontFamily="'Space Grotesk', sans-serif"
        fontWeight="700"
        fontSize={fontSize}
        color="text.primary"
        letterSpacing="-0.02em"
        lineHeight="1"
      >
        yetzira
      </Text>
      <Text
        fontFamily="'Space Grotesk', sans-serif"
        fontWeight="500"
        fontSize={fontSize}
        color="brand.400"
        letterSpacing="-0.02em"
        lineHeight="1"
      >
        .ai
      </Text>
    </Box>
  );
}